/**
 * localStorage for per-visitor conveniences only. Storage may be missing or
 * throw (private mode, blocked site data), so every access is guarded and
 * the site works without it.
 */

export function readItem(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null; // storage unavailable: behave as if nothing was stored
  }
}

export function writeItem(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // storage unavailable or full: the value is a convenience, nothing to do
  }
}
